export default "__VITE_ASSET__Cpwk4oxX__"